import { useCurrentElement } from '@vueuse/core';
import { computed, inject, provide, type Ref } from 'vue';

export const provideScrollParentContext = (el: Ref<HTMLElement | undefined>) => {
  provide('scrollParent', el);
};

export const useScrollParentContext = () => {
  const scrollParent = inject<Ref<HTMLElement | undefined>>('scrollParent');
  const currentElement = useCurrentElement();

  const offset = computed(() => {
    const parentRect = scrollParent?.value ? scrollParent.value.getBoundingClientRect() : null;
    const elementRect =
      currentElement.value && 'getBoundingClientRect' in currentElement.value
        ? currentElement.value.getBoundingClientRect()
        : null;

    if (!elementRect) {
      console.warn('Current element is not available for offset computation');
      return { top: 0, left: 0, right: 0, bottom: 0 };
    }

    if (!parentRect) {
      return {
        top: elementRect.top,
        left: elementRect.left,
        right: elementRect.right,
        bottom: elementRect.bottom,
      };
    }

    return {
      top: elementRect.top - parentRect.top,
      left: elementRect.left - parentRect.left,
      right: parentRect.right - elementRect.right,
      bottom: parentRect.bottom - elementRect.bottom,
    };
  });

  return {
    scrollParent,
    currentElement,
    offset,
  };
};
